import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Doctors } from "@/components/Doctors";
import { Testimonials } from "@/components/Testimonials";
import { Gallery } from "@/components/Gallery";
import { Appointment } from "@/components/Appointment";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingActions } from "@/components/FloatingActions";
import { useReveal } from "@/hooks/useReveal";

function App() {
  useReveal();

  return (
    <div className="App min-h-screen bg-[#F7FAFC] text-[#1F2937] font-[Plus_Jakarta_Sans]">
      <Navbar />
      <main data-testid="main-content">
        <Hero />
        <About />
        <Services />
        <WhyChooseUs />
        <Doctors />
        <Testimonials />
        <Gallery />
        <Appointment />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}

export default App;
